import { replacePlaceholderOnPath } from "./replace-placeholder-on-path";

export function addMemberIdToPath(path: string, memberId: string) {
  return replacePlaceholderOnPath(path, ":memberId", memberId);
}
